import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CaseDetail from "@/pages/CaseDetail";
import ApprovalQueue from "@/pages/ApprovalQueue";
import Notifications from "@/pages/Notifications";
import AuditLog from "@/pages/AuditLog";
import ConfigPage from "@/pages/ConfigPage";
import UsersPage from "@/pages/UsersPage";
import CalendarPage from "@/pages/CalendarPage";
import HearingsPage from "@/pages/HearingsPage";
import ReportsPage from "@/pages/ReportsPage";
import WorkloadPage from "@/pages/WorkloadPage";
import SecurityPage from "@/pages/SecurityPage";
import VerifyReceiptPage from "@/pages/VerifyReceiptPage";
import AttendPage from "@/pages/AttendPage";
import LodgePage from "@/pages/LodgePage";
import LodgementRulesPage from "@/pages/LodgementRulesPage";
import NonCompliancePage from "@/pages/NonCompliancePage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import RegisterPage from "@/pages/RegisterPage";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.enrolment_required && loc.pathname !== "/security") return <Navigate to="/security" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/verify-receipt" element={<VerifyReceiptPage />} />
          <Route path="/attend" element={<AttendPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/cases/:id" element={<CaseDetail />} />
            <Route path="/approvals" element={<ApprovalQueue />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/config" element={<ConfigPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/hearings" element={<HearingsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/workload" element={<WorkloadPage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/lodge" element={<LodgePage />} />
            <Route path="/lodgement-rules" element={<LodgementRulesPage />} />
            <Route path="/non-compliance" element={<NonCompliancePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
